/// <reference path="../../../jquery/jquery.d.ts" />

// Used for the notification handler - the obj is global, but TS compiler fails to read it.

interface UserResponse {
    tokenID  : string,
    userbase : string,
    webID    : number
}

interface CreditResponse {
    result     : string,
    credit     : number,
    inCurrency : number,
    topups     : number,
    reg_date   : string,
    query      : string,
    spECP      : boolean
}

interface SexChatResponse {
    error       : boolean|string,
    info        : boolean|string,
    showCaptcha : boolean,
    stat        : any,
    visible     : boolean
}

module Sxc.Site {

    export class GeneralHandler { //Legacy name: BabesHandler

        private translateJSON : any = {};
        private roomlist;
        public helpers;

        constructor(roomlist,helpers:Helpers) {
            this.roomlist=roomlist;
            this.helpers=helpers;

            let thisref = this;
            if(window.location.href.indexOf("/videos") !==-1){
                // @ts-ignore
                window.directGallery=true;
                $(document).ready( () =>{
                    $(".content-loading-roomlist").show();
                    setTimeout(function (){
                        thisref.openMainVideoGallery();
                        $(".content-loading-roomlist").hide();
                    },2000);
                });
            }
            if(window.location.href.indexOf("/babes") !== -1) {
                window.history.replaceState("", "", '/live');
            }
            if(window.location.href.indexOf("#achievements") !== -1) {
                thisref.roomlist._openAchievements();
            }
        }

        init() : Promise<void> {
            return new Promise((resolve, reject) => {
                this.getLanguageJSON()
                    .then(() => {
                        this._bindShortKey();
                        this._bindDOMEvent();

                        this._settings_menuHandler();
                        this._popup_fixcontentsHandler();

                        this.setuphappyhour();
                        this.setupchatloaded();
                        this.setupTopupZeroPopup();
                    })
                    .then(resolve, reject);
            });
        }

        /**
         * Happy hour megjelenítése és frissítése
         */
        setuphappyhour(){
            //window["echh"] = new EcHappyHour(); //Régi design módszer
            let thisref=this;
            //$(window).load(function () {thisref._checkHappyHourPromo();});
            setInterval(() => { this._checkHappyHourPromo(); }, 15000);
        }

        /**
         * Chat betöltése utáni műveletek
         */
        setupchatloaded(){
            this._checkTopupBalance();
            let _this=this;
            setInterval(() => { this._checkTopupBalance(); }, 30000);
            let thisref=this;
            $(document).ready(function () {
                let waiter = setInterval(function() {
                    // @ts-ignore
                    if ( typeof chatClient !== 'undefined') {
                        thisref._checkTopupBalance();
                        clearInterval(waiter);
                    }
                }, 300);
                // @ts-ignore
                if(__isLoggedMember){
                    let waiter2 = setInterval(function() {
                        if ($(".sxcc-topup-panel .sxcct-picker").length>0) {
                            clearInterval(waiter2);
                            thisref._checkTopupBalance();
                        }
                    }, 300);

                    let waiter3 = setInterval(function() {
                        if ($(".topup-button").length>0) {
                            console.log("setup complete");
                            clearInterval(waiter3);
                            $("#topupmenu,#creditadd_menuitem").show();
                            thisref._checkTopupBalance();

                            //Wheelpromo turn on
                            // @ts-ignore
                            window.wheelPromoHandler = new WheelPromo();
                        }
                    }, 300);
                }

                //login form bind
                $("#loginform").submit(function (e) {
                    e.preventDefault();
                    _this.signinHandler(e);
                });
            });

            //Fancybox bug javítása régebbi jQuery verzió miatt
            jQuery.fn.addBack = jQuery.fn.andSelf;
        }

        /**
         * 1 hét utáni 0 kredit és 0 feltöltés esetén popup ok megjelenítése időnként
         */
        private activitychecker=0;
        public activitychecker_random=100;
        showZeroTopupPopupIfNecessary(){
            if(this.topups==0 && this.current_credits==0 //&& ( Math.abs(new Date().getTime() - new Date(Date.parse(this.reg_date)).getTime()) / (60*60*1000)) > 24*7
                && this.activitychecker>this.activitychecker_random && !$(".sxcc-topup-panel").is(":visible")){
                // @ts-ignore
                if(roomListNG.refInfo.refInfo.length === 0){
                    window["chatClient"].app.view.topupPanel.needFirstZeroCredit=true;
                    window["chatClient"].app.view.topupPanel.needFirstCredit=true;
                }
                window["chatClient"].app.view.topupPanel.show(true);
                this.activitychecker=0;
                try{window["cookie"].erase("activitychecker");}catch (err){}
                try{window["cookie"].create("activitychecker", this.activitychecker);}catch (err){}
                this.activitychecker_random=this.GetRand(40,80);
            }
        }
        setupTopupZeroPopup(){
            let thisref=this;
            thisref.activitychecker_random=this.GetRand(40,80);
            try{
                if(typeof window["cookie"] !== undefined){
                    let cookieval=window["cookie"].read("activitychecker");
                    if(typeof cookieval !== undefined && cookieval!=null && cookieval.length>0){
                        this.activitychecker=parseInt(cookieval);
                    }
                }
            }catch (err){}
            setTimeout(function () {
                $(".sxcc-stream-wrapper,.sxcc-chat,.sxcc-sampler,.sxcc-special-gift-panel").mousedown(function () { thisref.activitycheckeradd();  });
                $('.sxcc-chat-form-input,.performercontent .mediagallery').keydown(function (e){
                    if(e.keyCode == 13){  thisref.activitycheckeradd(); }
                })
            },5000);
        }
        activitycheckeradd(){
            let thisref=this;
            if(thisref.topups==0 && thisref.current_credits==0 //&& ( Math.abs(new Date().getTime() - new Date(Date.parse(thisref.reg_date)).getTime()) / (60*60*1000)) > 24*7
                && !$(".sxcc-topup-panel").is(":visible")
            ){
                thisref.activitychecker++;
                window["cookie"].erase("activitychecker");
                window["cookie"].create("activitychecker", thisref.activitychecker);
                //console.log("activitychecker:"+thisref.activitychecker+" / "+thisref.activitychecker_random);
                thisref.showZeroTopupPopupIfNecessary();
            }
        }

        /**
         * Random integer
         */
        GetRand(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive
        }


        /**
         * Szöveges tartalmak felugró ablakban - kezelés
         */
        _popup_fixcontentsHandler() {
            let thisref=this;
            $(document).ready(function() {
                //fixcontents open in popup form url
                let urlelements = window.location.href.replace(/\/$/, "").replace(/\#(.*)$/, "").split("/");
                let location = "";
                if (urlelements.length >= 1) {
                    location = urlelements[urlelements.length - 1];
                }
                if (location != "") {
                    if ( ["terms", "privacy", "voxebankinfo", "happyhourrules", "2257", "btk222","billingsupport","faq","contact"].indexOf(location) !==-1)  {
                        thisref._popup_default_loadcontent("/"+location)
                    }
                    if(window.location.href.indexOf("/help") !==-1){
                        let afterurl=window.location.href.split("/help")[1] || "";
                        thisref._popup_default_loadcontent("/help"+afterurl);
                    }
                }

                //footer links open popup
                $(".footer-links a.openinpopup").click(function (e) {
                    e.preventDefault();
                    let afterurl=$(this).attr("href");
                    if(afterurl=="/help"){afterurl="/help/whatis?g=topup";}
                    thisref._popup_default_loadcontent(afterurl);
                });

                //over18 links open popup
                $("#over18 .text a").click(function (e) {
                    e.preventDefault();
                    let afterurl=$(this).attr("href");
                    thisref._popup_default_loadcontent(afterurl);
                });
            });
        }

        /**************************************************************************/

        /**
         * Happy hour ellenőrzés ciklikusan (Ha van új Happy hour, reload)
         */
        public hhour_timeout=-1;
        public tright_timeout=-1;
        public thepromo=null;
        private checkhappy=false;
        async _checkHappyHourPromo(opentopup=false, calledfromroomlist=false) {
            if(this.checkhappy){return;}
            // @ts-ignore
            if((typeof roomListNG !== 'undefined' && roomListNG.roomlistisloading) && !calledfromroomlist){
                if(opentopup){
                    let opened=await this.helpers.gdprFirstCreditShowpopup();
                    if(!opened){window["chatClient"].app.view.topupPanel.show();}
                    this.checkhappy=false;
                    return;
                }
            }

            let _thisObj = this;

            _thisObj.checkhappy=true;
            let timout=setTimeout(function () { _thisObj.checkhappy=false;},5000);
            try {
                return new Promise<void>((resolve, reject) => {
                    $.ajax({
                        url: '/ajax/api/getPromos',
                        type: 'GET',
                        dataType: 'json',
                        data: {},
                        complete: async function(data) {
                            //setTimeout(function () {
                                if(opentopup){
                                    let opened=await _thisObj.helpers.gdprFirstCreditShowpopup();
                                    if(!opened){window["chatClient"].app.view.topupPanel.show();}

                                    console.log("TEST OPEN");
                                }
                                //},150);//A set timout kell, hogy később mutatódjon, minthogy a promo object elkészül, máskülönben bugosan behozza a first promo bankkártyás oldalt
                            _thisObj.checkhappy=false;
                            clearTimeout(timout);
                        },error(jqXHR: JQueryXHR, textStatus: string, errorThrown: string): any {
                            reject();
                        }
                    }).done((responseJSON) => {
                        let addgraphics=false;
                        // @ts-ignore
                        if (responseJSON.result === true && (securionPayHandler.promo==null ||  _thisObj.hhour_timeout==-1 || (securionPayHandler.promo!=null && securionPayHandler.promo.promo==null ))) {//alert(_thisObj.hhour_timeout+" "+ securionPayHandler.promo);
                            try{
                                addgraphics=true;
                                // @ts-ignore
                                if((securionPayHandler.promo==null || (securionPayHandler.promo!=null && securionPayHandler.promo.promo==null ) )){
                                    // @ts-ignore
                                    try{securionPayHandler.promo.clearPromo();}catch (e) {}
                                    // @ts-ignore
                                    try{_thisObj.thepromo = new Sxc.SecurionPay.ExtraCreditPromo("echh", responseJSON.extraCredit.priceTable, responseJSON.extraCredit.start * 1000, responseJSON.extraCredit.end * 1000, responseJSON.extraCredit.scriptParams);
                                    }catch (e) {console.error(e)}
                                    if(!$(".sxcc-topup-panel").is(":visible")) {
                                        setTimeout(function () {
                                            // @ts-ignore
                                            securionPayHandler.promo.setExtraCreditPromo(_thisObj.thepromo);
                                        }, 90);//A set timout kell bug miatt
                                    }
                                }
                                // @ts-ignore
                                //if(typeof roomListNG !== 'undefined'){roomListNG._loadRoomList();}
                            }catch (e) { console.error(e) }

                            //auto remove after end
                            if(responseJSON.extraCredit.end>0){
                                try{clearTimeout(_thisObj.hhour_timeout);}catch(ex){}
                                // @ts-ignore
                                _thisObj.hhour_timeout=setTimeout(() => {
                                    try{clearTimeout(_thisObj.hhour_timeout);}catch(ex){}
                                    _thisObj.hhour_timeout=-1;
                                    // @ts-ignore
                                    try{securionPayHandler.promo.clearPromo();}catch (e) {}
                                    if($('#roomlist .happy-hour-promo').length>0){
                                        $('#roomlist .happy-hour-promo').remove();//_thisObj._loadRoomList();
                                        // @ts-ignore
                                        if(typeof roomListNG !== 'undefined'){roomListNG._addlastrooms_if_required(true);}
                                    }
                                },(responseJSON.extraCredit.end-Math.ceil(new Date().getTime()/1000))*1000);
                            }
                        }
                        if(responseJSON.result === false){
                            try{clearTimeout(_thisObj.hhour_timeout);}catch(ex){}
                            _thisObj.hhour_timeout=-1;
                            // @ts-ignore
                            try{securionPayHandler.promo.clearPromo();}catch (e) {}
                            // @ts-ignore
                            if($('#roomlist .happy-hour-promo').length>0){
                                $('#roomlist .happy-hour-promo').remove();//_thisObj._loadRoomList();
                                // @ts-ignore
                                if(typeof roomListNG !== 'undefined'){roomListNG._addlastrooms_if_required(true);}
                            }
                        }

                        //Topright
                        if (responseJSON.result_topright === true && _thisObj.tright_timeout==-1) {
                            addgraphics=true;
                            //auto remove after end
                            if(responseJSON.extraCredit.end>0){
                                try{clearTimeout(_thisObj.tright_timeout);}catch(ex){}
                                // @ts-ignore
                                _thisObj.tright_timeout=setTimeout(() => {
                                    // @ts-ignore
                                    _thisObj.tright_timeout=-1;
                                    if($('.top-right-promo').length>0){
                                        $('.top-right-promo').remove();//_thisObj._loadRoomList();
                                        // @ts-ignore
                                        if(typeof roomListNG !== 'undefined'){roomListNG._addlastrooms_if_required(true);}
                                    }
                                },(responseJSON.extraCredit.end-Math.ceil(new Date().getTime()/1000))*1000);
                            }
                        }
                        if(responseJSON.result_topright === false){
                            _thisObj.tright_timeout=-1;
                            // @ts-ignore
                            if($('.top-right-promo').length>0){
                                $('.top-right-promo').remove();//_thisObj._loadRoomList();
                                // @ts-ignore
                                if(typeof roomListNG !== 'undefined'){roomListNG._addlastrooms_if_required(true);}
                            }
                        }

                        //Small banner Promo
                        // @ts-ignore
                        roomListNG._rendersmallPromo(roomListNG,responseJSON);

                        //Add graphics
                        if (addgraphics) {
                            // @ts-ignore
                            roomListNG._renderHappyHourPromo(responseJSON==null?"notnull":responseJSON);
                        }
                        resolve();
                    });
                });

            } catch(ex) { console.error(ex); }
        }

        /**************************************************************************/

        /**
         * Balance ellenőrzése. Ha kevesebb, mint 1000 villogó piros pötty
         */
        private observer_fortopup=null;
        _checkTopupBalance(onlyobserver=false) {
            let _thisObj = this;
            if(!onlyobserver){
                this.getCreditNumber().then(function(creditNumber) {
                    $('.credit-indicator').removeClass( 'red-topup').removeClass( 'green-topup');
                    $('.credit-indicator').addClass( ((creditNumber < 1000) ? 'red-topup' : 'green-topup') );
                    $("#creditval").text(String(creditNumber));

                    //first topup promó ektüntetése topup után ha szükséges
                    if($(".sxcc-stream-promo").is(":visible") && !$('.sxcc-topup-panel').is(":visible") && _thisObj.topups>0){
                        $(".sxcc-stream-promo").remove();
                    }
                });
            }

            //Kreditek mutatása a popupban is
            if($('.sxcc-topup-panel').length>0 && $(".sxcc-topup-panel[data-observed='true']").length==0){
                this.observer_fortopup = new MutationObserver(function(mutations) {
                    if($(".sxcc-topup-panel > .credit").length==0){
                        $("#creditcont").clone().insertAfter(".sxcc-topup-panel .sxcct-picker").show();
                    }
                    _thisObj._checkTopupBalance();
                    _thisObj._checkHappyHourPromo();
                    if(!$(".sxcc-topup-panel").hasClass("sxc-visible")){
                        $("body").removeClass("topup-opened");
                    }else{
                        $("body").addClass("topup-opened");
                    }
                });
                this.observer_fortopup.observe($('.sxcc-topup-panel')[0], {  attributes: true   });
                $('.sxcc-topup-panel').attr("data-observed","true");
            }
        }

        /**
         * Popupba ajax tartalom betöltés
         */
        _popup_default_loadcontent(url) {
            let thisref=this;

            //Cím beállítása
            let title= $(".footer-links a[href*='"+url+"']").text();
            if(url.indexOf("/help") !==-1){title= $(".footer-links a[href*='/help']").text();}
            if(title!=""){
                $('#defaultpop .window .header').text(title);
            }

            $('#defaultpop .window').attr("data-url",url);

            $('#defaultpop').removeClass('hidden');
            $("#defaultpopcontent").css("visibility","hidden");
            window.history.replaceState("", "", url);
            if(["/billingsupport","/contact","/faq"].indexOf(url) !==-1 || url.indexOf("/help") !==-1){//old design get content
                let ajaxfaq="1";
                if(url.indexOf("/help") !==-1){ajaxfaq="0";}
                $.get( url, {ajax: "1",ajaxfaq:ajaxfaq }, function( data ) {
                    $('#defaultpopcontent').animate({scrollTop:0}, 1);
                    data=data.replace('id="longtext"','');
                    let data2=$(data).find(".scrollPanel").next();
                    $("#defaultpopcontent").html($(data2)[0].outerHTML);
                    $("#defaultpopcontent a").each(function () {
                       if($(this).attr("href").indexOf("http")===-1){
                           $(this).click(function (e) {
                               e.preventDefault();
                               thisref.hidePopup();
                               thisref._popup_default_loadcontent($(this).attr("href"));
                           });
                       }
                    });
                    $("#defaultpopcontent").css("visibility","visible");
                    if(["/contact"].indexOf(url) !==-1 ){
                        thisref.contact_form_handler();
                    }
                });

            }else{//default longtext
                $.get( url, { ajax: "1"}, function( data ) {
                    $('#defaultpopcontent').animate({scrollTop:0}, 1);
                    $("#defaultpopcontent").html(data);
                    $("#defaultpopcontent").css("visibility","visible");
                });
            }
            $('#defaultpopcontent').scrollbar();
        }

        /**
         * Pupup típusú kapcsolati form handler
         */
        contact_form_handler() {
            let thisref=this;
            $(".supportform_input input[type='image']").clone().attr("type","submit").insertAfter(".supportform_input input[type='image']");
            $(".supportform_input input[type='image']").hide();
            $("#defaultpopcontent form").submit(function (e) {
                e.preventDefault();
                var data = $(this).serialize()+"&ajax2=1&token="+$("[name='g-recaptcha-response']").val();
                $.post( "/contactajax?ajax=1", data, function( data ) {
                    let data2=$(data).find(".scrollPanel").next();
                    $("#defaultpopcontent").html($(data2)[0].outerHTML);
                    if($("#defaultpopcontent #errorlist li").length>0){$("#defaultpopcontent #errorlist").show();}
                    $("#defaultpopcontent a").each(function () {
                        if($(this).attr("href").indexOf("http")===-1){
                            $(this).click(function (e) {
                                e.preventDefault();
                                thisref.hidePopup();
                                thisref._popup_default_loadcontent($(this).attr("href"));
                            });
                        }
                    });
                    $("#defaultpopcontent").css("visibility","visible");
                    thisref.contact_form_handler();
                });
                return false;
            });
        }

        /**
         * Popup bezárés
         */
        _popup_close() {
            $('#defaultpop,#successpop').addClass('hidden');
            if(window.location.href.indexOf("/live") === -1){window.history.replaceState("", "", "/live");}
        }

        /**************************************************************************/

        getLanguageJSON() : Promise<void> {
            return this.helpers._callGet('/ajax/api/language', {})
                .then((responseJSON) => { this.translateJSON  = responseJSON; });
        }
        

        /**************************************************************************/

        /**
         * Poppup megjelenítése
         */
        opening_popup=false;
        popup_original_html=$("#regpop_profile_pic_container").html();
        async showPopup(idName : string, profilePic=null, reason=null, reasonText=null) : Promise<void> {
            let _this=this;
            this.opening_popup=true;
            $('#'+idName).removeClass('hidden');
            console.log("Regpopup opening: "+reason, " reasonText: "+reasonText,  " profilePic: "+profilePic);

            //Auth popups templating
            if((idName=='regpop' || idName=='loginpop' || idName=='forgotpop' || idName=='forgotsentpop') && $("#auth_templates.newpopup").length>0){
                $("#wait").show();
                await new Promise(function(resolve, reject) {
                    var perfid="";
                    if(window.location.href.indexOf("/mypage")!==-1){
                        let arr1=window.location.href.split("/mypage/");let arr2=arr1[1].split("/");
                        perfid=((arr2[0]).split("?"))[0] || "";
                    }

                    $.ajax({  url: '/ajax/api/getAuthTemplate?template='+idName+'&reason='+reason+'&perfid='+perfid+'&reasonText='+reasonText,
                        complete:function(){
                            $("#wait").hide();
                            resolve("done");
                        },
                        success: function(data) {
                            _this.hidePopup();
                            $("#auth_templates.newpopup").html(data+'');
                            $('.newpopup').removeClass('hidden');
                            resolve(data) // Resolve promise and when success
                        },
                        error: function(err) {
                            _this.hidePopup();
                            reject(err) // Reject the promise and go to catch()
                        }
                    });
                });
            }

            // aff2 integration: fire a join_page event
            if (idName == 'regpop') {
                $.ajax({
                    url: '/ajax/aff2/joinPage',
                    dataType: 'json',
                })
                .always(() => {
                    // results are not important now
                });
            }

            $('#'+idName+" .tooltip").css("visibility","hidden");
            $('#'+idName+" input:first").focus();
            if($('#'+idName+" input").length==0){
                $('#'+idName+" textarea:first").focus();
                if($('#'+idName+" textarea").length==0){
                    $('#'+idName+" select:first").focus();
                }
            }
            $('#'+idName+" *").focus(function () {
                if(!_this.opening_popup){$('#'+idName+" .tooltip").css("visibility","visible");}
            });
            this.opening_popup=false;
        }

        /**
         * Popup eltüntetése
         */
        hidePopup(hideReg=false) : void {
            $('.popup:visible:not(.new)').addClass('hidden');
            $('.newpopup:visible').addClass('hidden');
            if($('.newpopup').html().indexOf("keyCode")!==-1){
                $('body').trigger($.Event('keydown', { keyCode: 27 }));
            }

            //if(hideReg){
                $("#sxcc-obj-wrapper").appendTo(".sxcc-stream");
                $("#sxcc-obj-wrapper").removeClass("sxccs-float-over-reg");
                $("#sxcc-obj-wrapper").removeClass("sxccs-float-over-reg-mini");
                $("#sxcc-obj-wrapper").removeClass("in-newpopup");
            //}

            if(window.location.href.indexOf("#achivements") !== -1) {
                window.history.replaceState("", "", '/live');
            }
        }

        /**
         * Hibaüzenet megjelenítése a popup űrlappon
         */
        showPopupError(fieldId : string, errorMsg : boolean|string) {
            $('#'+fieldId).addClass('sxcf-has-error');

            let errorDivElement = $('<div>').addClass('error-msg').addClass('required').html(<string>errorMsg);
            let containerDivElement = $('<div>').addClass('errors').addClass('errors-bottom-left').addClass('visible').append(errorDivElement);

            $('#'+fieldId).parent().append(containerDivElement);
        }

        /**
         * Hibaüzenetek törlése a popup űrlapról
         */
        clearPopupError() {
            $('.sxcf-has-error').each((itemIndex, itemObj) => { $(itemObj).removeClass('sxcf-has-error'); });
            $('.errors').remove();
        }

        /**
         * Beállítások menü új elrendezés kezelője
         */
        _settings_menuHandler() {
            $(document).ready(function () {
                $("#header").find(".userMenu .settings").on("click", "a", (e) =>
                {
                    var $link = $(e.currentTarget);
                    var url = $link.attr("href");
                    if (url.substr(0,11) === "/myaccount/") {
                        $("#frame_myaccount:not(.faqpop) .content-wrapper").insertAfter($("#frame_myaccount .sidebar li[data-name*='"+url.replace("/myaccount/","")+"']"));
                    }
                    $("#frame_myaccount .sidebar:not(#faq) li").click(function () {
                        $("#frame_myaccount .sidebar:not(#faq) .content-wrapper").insertAfter($(this));
                    });
                });
            });
        }

        /**************************************************************************/

        /**
         * Felbindeli a short kódokat az eseményekkel
         */
        _bindShortKey() : void {
            let _thisObj = this;

            $(document).keyup(function(e) {
                if (e.keyCode == 27  && !$("#defaultpop").is(":visible")) { // escape
                     console.log("triggeresc");

                    if ( !$(".fancybox-container").is(":visible") && !$(".popup").is(":visible")
                        && !$(".sxcc-tip-after-show-wrapper").is(":visible") && !$(".sxcc-topup-panel").is(":visible")
                        && !$("#perfsearch").is(":visible") && !$(".sxcc-auth-panel-wrapper").is(":visible") && !$(".sxcc-gift-panel").hasClass("sxc-visible") &&
                        !$("div[role='presentation']").is(":visible") && !$("#frame_myaccount").is(":visible") && !$("#main_video_gallery").hasClass("hidden")){
                        _thisObj.closeMainVideoGallery();
                    }else{
                        setTimeout(function () { _thisObj.hidePopup();},50);
                    }

                }
                else if (e.keyCode === 27 && $("#defaultpop").is(":visible")){
                    // @ts-ignore
                     setTimeout(function () { _thisObj._popup_close();},50);
                }

                if (e.keyCode == 13 && !$(e.target).has("#sup_message")) {// enter
                     if($('.popup').not('.hidden').length == 0) { return; }

                     $('.popup').not('.hidden').find('button').trigger('click');
                }
            });

            $(document).ready(function () {
                //design fix
                $("input,textarea").keyup(function () {
                    if($(this).val()!=""){
                        $(this).addClass("sxcf-has-content");
                    }else{
                        $(this).removeClass("sxcf-has-content");
                    }
                });
            });
        }

        /**
         * Felbindeli az eseményeket a dom fára
         */
        _bindDOMEvent() : void {
            $( document ).on('click', '.favorite', (domObj) => {
                this.favoriteHandler( $(domObj.target).data('perfid') );
            });
        }

        /**************************************************************************/

        private signUpCalling=false
        async signupHandler(event) {
            if(!event.isTrusted){return;}
            // @ts-ignore
            const isValid = await verifyAltcha();
            if (!isValid) {
                return;
            }

            let thisref=this;
            if(thisref.signUpCalling){return;}
            thisref.signUpCalling=true;
            this.clearPopupError();  // Hibaüzenetek törlése az űrlapról
            $("#regbutton").prop("disabled","true");

            $("#wait").show();
            $('#wait').css("position","fixed");
            this.helpers._callPost('/', {
                action: 'join',
                userid: $('#signup_name').val(),
                email: $('#signup_email').val(),
                passwd: $('#signup_pass1').val(),
                passwd2: $('#signup_pass2').val(),
                token: $("#regpop:not(.hidden) input[name='altcha']").val(),
                ajax: 1
            },function () {
                $("#wait").hide();
                $('#wait').css("position","absolute");
            }).then((responseJson : SexChatResponse) => {
                thisref.signUpCalling=false;
                if(responseJson.error === false) {
                    this.hidePopup();
                    this.showPopup("successpop");
                } else {
                    $("#regbutton").removeAttr("disabled");
                    if((<string>responseJson.error).indexOf("pass")!==-1){
                        $('#signup_pass1').focus();
                        this.showPopupError('signup_pass1', this.helpers.getTranslate(<string>responseJson.error));
                    }else if((<string>responseJson.error).indexOf("email")!==-1){
                        $('#signup_email').focus();
                        this.showPopupError('signup_email', this.helpers.getTranslate(<string>responseJson.error));
                    }else{
                        $('#signup_name').focus();
                        this.showPopupError('signup_name', this.helpers.getTranslate(<string>responseJson.error));
                    }
                    // @ts-ignore
                    reCAPTCHA_execute();
                }
            });
        }

        private signinIsCalling=false
        async signinHandler(event)  {
            if(!event.isTrusted){return;}
            // @ts-ignore
            const isValid = await verifyAltcha();
            if (!isValid) {
                return;
            }

            let thisref=this;
            if(thisref.signinIsCalling){return;}
            thisref.signinIsCalling=true;
            $("#signinbutton").prop("disabled","true");
            this.clearPopupError();  // Hibaüzenetek törlése az űrlapról
            this.helpers._callPost('/', {
                action: 'login',
                userid: $('#signin_name').val(),
                passwd: $('#signin_passwd').val(),
                token: $("#loginpop:not(.hidden) input[name='altcha']").val(),
                rememberme: $('#loginPanelRememberme').is(":checked") ? "1" : "",
                ajax: 1
            }).then((responseJson : SexChatResponse) => {
                thisref.signinIsCalling=false;
                if(responseJson.error === false) {
                    location.href = location.href.substr(0, location.href.indexOf('#')) || location.href ;
                } else {
                    $("#signinbutton").removeAttr("disabled");
                    this.showPopupError('signin_name', this.helpers.getTranslate(<string>responseJson.error));
                    this.showPopupError('signin_passwd', this.helpers.getTranslate(<string>responseJson.error));
                    $('#signin_name').focus();
                    // @ts-ignore
                    reCAPTCHA_execute();
                }
            });
        }

        logoutHandler() : void {
            this.helpers._callGet('/ajax/api/logout', {})
                .then(() => { location.href = location.href.substr(0, location.href.indexOf('#')) || location.href });
        }

        backToOldDesignHandler() : void {
            window["cookie"].erase("old_design");
            window["cookie"].create("old_design", "1");
            location.href ="/";
        }

        goToNewdDesignHandler() : void {
            window["cookie"].erase("old_design");
            window["cookie"].create("old_design", "0");
            location.href ="/";
        }

        reminderHandler(reason=null,reasonText=null) : void {
            this.clearPopupError();  // Hibaüzenetek törlése az űrlapról

            this.helpers._callPost('/', {
                action: 'reminder',
                email: $('#reminder_email').val(),
                ajax: 1,
            }).then((responseJson : SexChatResponse) => {
                if(responseJson.error === false) {
                    this.hidePopup();
                    this.showPopup('forgotsentpop',null, reason,reasonText);
                } else {
                    this.showPopupError('reminder_email', this.helpers.getTranslate(<string>responseJson.error));
                    $('#reminder_email').focus();
                }
            });
        }

        favoriteHandler(performerId, contclass=".room-item-", forced=false, isFavoritedRoomForcedVal= false) {
            let isFavoritedRoom = $(contclass+''+performerId).find('.favorite').hasClass('on');
            if(forced){isFavoritedRoom=isFavoritedRoomForcedVal;}

            this.helpers._callPost('/ajax-favourites', {
                command: ((isFavoritedRoom) ? 'del' : 'add'),
                perfid: performerId
            }).then(() => {
                if(isFavoritedRoom) {
                    $(contclass+''+performerId).find('.favorite').removeClass('on');
                } else {
                    $(contclass+''+performerId).find('.favorite').addClass('on');

                    // Handle enable notifications - only when favorited the room.
                    // @ts-ignore
                    if (!notificationPopup.hasBeenAccepted()) {
                        // Remove "v" placement from performerId so we can use it.
                        let perfid = performerId;

                        window["addToFavoriteEvent"](perfid);
                    }
                }
                this.roomlist.getFavourites();
            });
        }

        /**************************************************************************/

        private current_credits=-1;
        private topups=-1;
        public reg_date=new Date()+"";
        public getCreditNumber() {
            return new Promise((resolve, reject) => {
                this.helpers._callGet('/ajax/credit/getcredits', {"topups":"1"//,"reg_date":"1"
                }).then((responseJSON : CreditResponse) => {
                    if(responseJSON.result == 'success') {
                        // @ts-ignore
                        if ("wheelPromo" in responseJSON && responseJSON.wheelPromo!=null) {
                            console.log("[creditDisplayHandler][update]", "Calling wheel promo handler");
                            // @ts-ignore
                            if ("wheelPromoHandler" in window) window.wheelPromoHandler.update(responseJSON.wheelPromo);
                        }

                        //Zero Popup funcion
                        this.current_credits=responseJSON.credit;
                        this.topups=responseJSON.topups;
                        //this.reg_date=responseJSON.reg_date;
                        this.showZeroTopupPopupIfNecessary();

                        resolve(responseJSON.credit);
                    } else {
                        resolve(0);
                    }
                });
            });
        }


        /* Gallery ---------------------------------------------------------------*/

        public openMainVideoGallery() {
            if (window["chatClient"].app.options.auth.tokenID === "guest") {return;}

            //streamek leállítása a szobalistában
            this.roomlist.roomView.stopStreamPreviews();
            $("#frame_chat-app").addClass("frame_chat-app-fullscreen");

            let thisref = this;
            this.roomlist.current_active_perf_id = 0;
            $("#main #roomlist").addClass("hidden");
            $("#main_video_gallery").removeClass("hidden");
            $('#main_video_gallery .mediagallery').html('');
            $("body").addClass("main_gallery_open");
            if($(".sxcc-user-data").length==0){ thisref.roomlist.roomView.roomgallery.addUserDataFrame(""); }

            if(window.location.href.indexOf("/videos")===-1){ window.history.pushState({},"", "/videos");}

            // @ts-ignore
            refreshGallerySearchList(true);
        }

        public closeMainVideoGallery() {
            let thisref = this;
            $("#main #roomlist").removeClass("hidden");
            $("#main_video_gallery").addClass("hidden");
            $("#frame_chat-app").removeClass("frame_chat-app-fullscreen");
            $('#main_video_gallery .mediagallery').html('');
            $("body").removeClass("main_gallery_open");

            // Start streams
            this.roomlist.current_active_perf_id = -1;
            if(new Date().getTime() -this.roomlist.lastrefreshed_ts>this.roomlist.roomlist_auto_refresh_seconds*1000){
                this.roomlist._loadRoomList(true,true);
            }else{
                this.roomlist._StartStreamsRandom();
            }

            window.history.pushState({},"", "/");
        }

        public filterMainVideoGallery(page="1") {
            let thisref = this;
            let mediaElement = $('#gallerycontent .mediagallery');
            if(page=="1"){$('#main_video_gallery .mediagallery').html('');}

            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set("page",page);

            $(".videos-gallery-loading").show();
            console.debug("[filterMainVideoGallery]", urlParams.toString());
            $.ajax({
                url: "/ajax/api/roomList/babes-get-gallery?",
                dataType: 'json',
                data : urlParams.toString(),
            }).done((dataJson) => {
                $(".videos-gallery-loading").hide();
                for(var i=0;i<dataJson.items.length;i++){
                    let liElement=thisref.roomlist.roomView.roomgallery.addVideoLiElement(dataJson.items[i].info, true);
                    liElement.attr("data-id",'mg-item-'+(new Date().getTime())+i);
                    mediaElement.append(liElement);
                }

                //paging
                if(dataJson.items.length==20){ $("#galleryshowmore").show();}else{$("#galleryshowmore").hide();}
                $("#galleryshowmore_btn").attr("data-page", parseInt($("#galleryshowmore_btn").attr("data-page"))+1);
                $("#galleryshowmore_btn").removeAttr("disabled");

                thisref.roomlist.roomView.roomgallery.facybox_settings();
            });
        }

        public async waitForEl (selector,timeout=30000) {
            var innergo=true;
            setTimeout(function(){innergo=false;},timeout);
            while ( $(selector).length==0 && innergo) {
                await new Promise( resolve =>  requestAnimationFrame(resolve) );
            }
            return $(selector);
        };

    }

}
